import React, { useState, useContext } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "../../components/Global/style";
import { DrawerHeader, LayoutContainer, Container, Content, OfflineAlert } from "./styles";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import WifiOffIcon from '@mui/icons-material/WifiOff';

import { ColorsContext } from "../../Context/ColorsContext";
import { useOffline } from "../../Context/OfflineContext";
import FloatingChatContainer from "../../components/FloatingChat/FloatingChatContainer";
import { useTranslation } from "react-i18next";

function Layout({
  children,
  openState,
  onChangeDemo,
  isDemo,
  reloadNotifications,
  updateTable,
  reloadWorkflows,
}) {
  const [open, setOpen] = useState(false);
  const { openBackDrop, contentRender } = useContext(ColorsContext);
  const { connectionStatus } = useOffline();
  const { t } = useTranslation();
  
  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      {/* Backdrop como overlay, sin bloquear el render del contenido */}
      <Backdrop
        sx={{ color:"#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <LayoutContainer id="Layout Container">
        <ThemeProvider theme={theme}>
          <Content fixed id="content-layout">
            <CssBaseline />
            <Navbar
              updateTable={updateTable}
              reloadNotifications={reloadNotifications}
              handleOpen={handleOpen}
              onChangeDemo={onChangeDemo}
              isDemo={isDemo}
              reloadWorkflows={reloadWorkflows}
            />
            <Sidebar open={open} isDemo={isDemo} setOpen={setOpen}/>
            <Container isOpen={open} component="main">
              <DrawerHeader />
              {!connectionStatus && (
                <OfflineAlert severity="warning" icon={<WifiOffIcon />}>
                  {t("common.offlineSyncNotice")}
                </OfflineAlert>
              )}
              {children}
            </Container>
            <Footer open={open} />
          </Content>
        </ThemeProvider>
      </LayoutContainer>
      <FloatingChatContainer />
    </>
  );
  }


  export default Layout;
